import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  root: {
    // width: "20vw",
    width: "auto",
    padding: "0px 10px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: "0"
    }
  },
  menuItemStyle: {
    backgroundColor: theme.palette.background.paper
  },
  selectStyles: {
    fontFamily: "Trebuchet",
    // width: "100%",
    width: "310px",
    height: 45,
    borderRadius: 8,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    fontSize: 16,
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    cursor: "pointer",
    "& >.MuiSelect-select:focus": {
      borderRadius: 8,
      borderColor: "#525c64",
      background: "transparent"
    },
    "& > fieldset": {
      borderRadius: 8,
      border: "1px solid #979797"
    },
    // "& fieldset:hover": {
    //   borderColor: "red"
    // },
    "& :hover": {
      borderColor: "#525c64"
    },
    "&> .MuiOutlinedInput-input": {
      padding: "10px 32px 10px 10px"
    },
    "& .MuiSelect-icon": {
      color: "#0073cf"
    },
    [theme.breakpoints.down("md")]: {
      width: "220px"
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      fontSize: "14px"
    }
  }
}));

export default styles;
